import React from 'react';
import { includes, map, groupBy, keys, sortBy, filter, some, toLower } from 'lodash';
import { GoogleSpreadsheet, GoogleSpreadsheetRow } from 'google-spreadsheet';
import { Container, Dropdown, Icon, Input, Menu, Table } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

const DataContext = React.createContext<Record<string, GoogleSpreadsheetRow[]> | null>(null);

const ALL_CATEGORY = 'All';
const HEADERS = ['Chinese', 'English', 'Example'];

function DataLoader({ children }: { children: React.ReactNode }) {
    const [data, setData] = React.useState<any>();

    React.useEffect(() => {
        const doc = new GoogleSpreadsheet('1-cgVNYDnOW-DfmJISsglwmQhYLErZDJ5pPxtqgdIku0');
        doc.useApiKey('AIzaSyAHreovafTCtmsUkqOW6VVKhyCluw4A58g');
        doc.loadInfo().then(async (e) => {
            const firstSheet = doc.sheetsByIndex[0]; // in the order they appear on the sheets UI
            const rows = await firstSheet.getRows();
            const rowsByCategory = groupBy(rows, 'Category');
            setData({ ...rowsByCategory, [ALL_CATEGORY]: rows });
        });
    }, []);

    return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
}

// https://sheets.googleapis.com/v4/spreadsheets/1-cgVNYDnOW-DfmJISsglwmQhYLErZDJ5pPxtqgdIku0?key=AIzaSyAHreovafTCtmsUkqOW6VVKhyCluw4A58g
//
function App() {
    return (
        <DataLoader>
            <Content />
        </DataLoader>
    );
}

// wah do routing eventually

function Content() {
    const data = React.useContext(DataContext);
    const categories = sortBy(keys(data));
    const [selectedCategory, setSelectedCategory] = React.useState(ALL_CATEGORY);
    const itemsForCategory = data?.[selectedCategory];
    const augmentedHeaders = selectedCategory === ALL_CATEGORY ? ['Category', ...HEADERS] : HEADERS;
    const [searchTerm, setSearchTerm] = React.useState('');
    const filteredItemsForCategory = filter(itemsForCategory, (item) => {
        return some(
            map(augmentedHeaders, (header) => item[header]),
            (valueToSearch) => includes(toLower(valueToSearch), toLower(searchTerm)),
        );
    });

    return (
        <div>
            <Menu fixed="top">
                <Menu.Menu>
                    <Dropdown text={selectedCategory} pointing className="link item">
                        <Dropdown.Menu>
                            {categories.map((categoryName) => (
                                <Dropdown.Item
                                    onClick={() => setSelectedCategory(categoryName)}
                                    key={categoryName}
                                >
                                    {categoryName}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Menu>
            <Container text style={{ marginTop: '4em' }}>
                <Input
                    fluid
                    icon={<Icon name="cancel" onClick={() => setSearchTerm('')} circular link />}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search..."
                />
                <Table celled unstackable>
                    <Table.Header>
                        <Table.Row>
                            {augmentedHeaders.map((header) => {
                                return <Table.HeaderCell key={header}>{header}</Table.HeaderCell>;
                            })}
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {map(filteredItemsForCategory, (item) => {
                            return (
                                <Table.Row key={item.Chinese}>
                                    {augmentedHeaders.map((header) => (
                                        <Table.Cell
                                            key={header}
                                            onClick={
                                                header === 'Category'
                                                    ? () => setSelectedCategory(item[header])
                                                    : undefined
                                            }
                                        >
                                            {item[header]}
                                        </Table.Cell>
                                    ))}
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </Container>
        </div>
    );
}

export default App;
